import type * as THREE from "three";
import type { AssetPipeline } from "../core/assets";
import type { MissionConfig } from "../mission/types";
import { Terrain } from "./terrain";
import { Map02Terrain } from "./map02";
import { Map03Terrain } from "./map03";
import { Map04Terrain } from "./map04";
import { Map05Terrain } from "./map05";
import { Map06Terrain } from "./map06";
import {
  ARCTIC_WOLF_ROUTE,
  ESCORT_ROUTE,
  GREEN_HAMMER_ROUTE,
  IRON_CURTAIN_ROUTE,
  IRON_MARKET_ROUTE,
  RIVER_VALLEY_ROUTE,
  type RouteNode,
} from "./nav";

// One registry for "which world does this mapId load" — the engine asks here
// instead of growing a ternary per theater. Adding a map = one entry each.

export function createMapTerrain(
  mapId: MissionConfig["mapId"],
  assets: AssetPipeline,
): { group: THREE.Group } {
  switch (mapId) {
    case "river-valley":
      return new Map02Terrain(2200, assets);
    case "iron-market":
      return new Map03Terrain(2200);
    case "green-hammer":
      return new Map04Terrain(2200);
    case "iron-curtain":
      return new Map05Terrain(2200);
    case "arctic-wolf":
      return new Map06Terrain(2200);
    default:
      return new Terrain({ size: 2000, segments: 100 }, assets);
  }
}

// Fallback squad route when the mission JSON doesn't carry one.
export function defaultRouteFor(mapId: MissionConfig["mapId"]): RouteNode[] {
  switch (mapId) {
    case "river-valley":
      return RIVER_VALLEY_ROUTE;
    case "iron-market":
      return IRON_MARKET_ROUTE;
    case "green-hammer":
      return GREEN_HAMMER_ROUTE;
    case "iron-curtain":
      return IRON_CURTAIN_ROUTE;
    case "arctic-wolf":
      return ARCTIC_WOLF_ROUTE;
    default:
      return ESCORT_ROUTE;
  }
}
